/* Replace neutralized YouTube embeds with accessible, click-to-load facades. */
(function () {
    const content = document.querySelector('.gh-content');

    if (!content) {
        return;
    }

    function parseVideoId(source) {
        try {
            const url = new URL(source, window.location.origin);
            const match = url.pathname.match(/\/embed\/([^/?]+)/);

            return match ? match[1] : '';
        } catch (error) {
            return '';
        }
    }

    function createFacade(frame) {
        const source = frame.dataset.youtubeSrc || frame.getAttribute('src') || '';
        const videoId = parseVideoId(source);

        if (!videoId) {
            return;
        }

        const title = frame.getAttribute('title') || 'YouTube video';
        const facade = document.createElement('button');
        const poster = document.createElement('img');
        const play = document.createElement('span');

        facade.type = 'button';
        facade.className = 'youtube-facade';
        facade.dataset.videoId = videoId;
        facade.dataset.title = title;
        facade.setAttribute('aria-label', `Play ${title}`);

        poster.className = 'youtube-facade__poster';
        poster.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
        poster.width = 480;
        poster.height = 360;
        poster.loading = 'lazy';
        poster.decoding = 'async';
        poster.alt = '';

        play.className = 'youtube-facade__play';
        play.setAttribute('aria-hidden', 'true');

        facade.appendChild(poster);
        facade.appendChild(play);
        frame.replaceWith(facade);

        facade.addEventListener('click', function () {
            const iframe = document.createElement('iframe');

            iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`;
            iframe.title = title;
            iframe.width = 1280;
            iframe.height = 720;
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';
            iframe.className = 'youtube-facade__player';

            facade.replaceWith(iframe);
        }, {once: true});
    }

    content.querySelectorAll([
        'iframe[data-youtube-src]',
        'iframe[src*="youtube.com/embed/"]',
        'iframe[src*="youtube-nocookie.com/embed/"]'
    ].join(',')).forEach(createFacade);

    lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');

    reframe(content.querySelectorAll([
        'iframe[src*="player.vimeo.com"]',
        'iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed'
    ].join(',')));
})();
